'use client';

import { useTranslations } from 'next-intl';

import { getLocaleFromPath } from '@/shared/api/client/base';
import ImageWithSkeleton from '@/shared/ui/image/ImageWithSkeleton';

const PcInformation = () => {
  const t = useTranslations('main.information');
  const locale = getLocaleFromPath();
  const langWidth = locale === 'zh-CN' ? 'w-[72px]' : 'w-[63px]';
  return (
    <section className="relative h-[300px] px-[30px] mb-[120px]">
      <div className="max-w-[1860px] mx-auto h-[300px] relative rounded-[40px] overflow-hidden">
        <ImageWithSkeleton
          src={'/images/information-banner.png'}
          alt={'information banner'}
          fill
          className="object-cover"
        />
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="flex text-[#FFFFFF]">
            <div className="mr-12 pr-12 border-r border-[#FFFFFF]">
              <h2 className="text-locale-28 font-bold whitespace-nowrap">{t('title')}</h2>
            </div>
            <div className="flex flex-col space-y-[4px] text-locale-18">
              <div className="flex items-center">
                <span className={`${langWidth} font-semibold`}>{t('tel_title')}</span>
                <span className="ml-[24px]">{`${t('tel1')}`}</span>
              </div>
              <div className="flex items-center">
                <span className={`${langWidth} font-semibold`}>{t('mail_title')}</span>
                <span className="ml-[24px]">call@koreavisa-qd.com</span>
              </div>
              <div className="flex items-start">
                <span className={`${langWidth} font-semibold`}>{t('time_title')}</span>
                <div className="ml-[24px] flex flex-col">
                  <span>{t('time')}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PcInformation;
